import { useNavigate } from 'react-router-dom';

import config from '@/config';
import useTranslations from '@/i18n/useTranslations';
import CardHeader from '@/shared-components/cards/components/CardHeader';
import Text from '@/shared-components/text/components/Text';
import Utils from '@/utils';
import { buildPublicContentPath } from '@/utils/contentRoutes';

import './styles/CommunityArticleCard.css';

export default function CommunityArticleCard({ article, actor }) {
  const navigate = useNavigate();
  const t = useTranslations('common.shared.community_feed');

  if (!article) return null;

  const articleId = article?._id || article?.id || article?.article_id;
  const coverImageId =
    article.coverImageId ||
    article.cover_image_id ||
    article.cover_image?.image_id;
  const coverUrl = coverImageId
    ? `${config.app.imageServiceDomain}/${coverImageId}/w=600`
    : null;

  const timeAgo = article.createdAt
    ? Utils.elapsedTime(new Date(article.createdAt).getTime())
    : null;

  const handleUserClick = e => {
    e.stopPropagation();
    if (actor?.username) navigate(`/user/${actor.username}`);
  };

  const handleCardClick = () => {
    if (articleId) navigate(buildPublicContentPath({ ...article, post_type: 'article' }, 'article'));
  };

  return (
    <div
      className="community-article-card__container"
      onClick={handleCardClick}
    >
      <CardHeader
        image={actor?.image}
        profileType={actor?.profileType}
        username={actor?.username}
        subtitle={t('activity.article')}
        timeAgo={timeAgo}
        onUserClick={handleUserClick}
      />

      {coverUrl ? (
        <img
          src={coverUrl}
          alt={t('article.cover_alt')}
          className="community-article-card__cover"
        />
      ) : (
        <div className="community-article-card__cover community-article-card__cover--placeholder" />
      )}

      <div className="community-article-card__content">
        <Text className="community-article-card__title">{article.title}</Text>
        {article.description && (
          <Text className="community-article-card__description" paragraph>
            {article.description}
          </Text>
        )}
      </div>
    </div>
  );
}
